import { createSelector } from "reselect";
import { DISMISS_BAG_ERROR, BAG_ITEM_DELETE_TRANSITION_END } from "./";

export const getBag = state => state.bag;

export const getLoading = createSelector(getBag, ({ loading }) => loading);

export const getBagItems = createSelector(getBag, ({ items }) => items);

export const getBagSummary = createSelector(getBag, ({ summary }) => summary);

export const getTotalPrice = createSelector(
  getBagSummary,
  ({ totalPrice }) => totalPrice || {}
);

export const getTotalPriceText = createSelector(
  getTotalPrice,
  ({ text }) => text
);

export const getTotalQuantity = createSelector(
  getBagSummary,
  ({ totalQuantity }) => totalQuantity
);

export const displayReservationMessage = createSelector(
  getBag,
  ({ displayReservationMessage }) => displayReservationMessage
);

export const bagError = createSelector(getBag, ({ bagError }) => bagError);

export const dismissBagError = () => {
  return dispatch => {
    dispatch({
      type: DISMISS_BAG_ERROR
    });
  };
};

export const getUpdated = createSelector(getBag, ({ isUpdated }) => isUpdated);

// why is this in here? ⬇️
export const bagItemDeleteTransitionEnd = itemId => dispatch =>
  dispatch({
    type: BAG_ITEM_DELETE_TRANSITION_END,
    itemId
  });
